<template>

<div id="slide05" class="section section-dark">

  <Subtitle :text="$t('home.slide05.title')"/>

  <Common :text="$t('home.slide05.text')"/>

  <div>

    <div class="one-third-block one-third-block-no-last">

      <div class="number">
        <Number text="10"/>
      </div>

      <div class="red-text">
        <Common :text="$t('home.slide05.block1.experience')"/>
      </div>

      <Common :text="$t('home.slide05.block1.description')"/>

    </div>

    <div class="one-third-block one-third-block-no-last one-third-block-no-first">

      <div class="number">
        <Number text="20"/>
      </div>

      <div class="red-text">
        <Common :text="$t('home.slide05.block2.experience')"/>
      </div>

      <Common :text="$t('home.slide05.block2.description')"/>

    </div>

    <div class="one-third-block one-third-block-no-first">

      <div class="number">
        <Number text="15"/>
      </div>

      <div class="red-text">
        <Common :text="$t('home.slide05.block3.experience')"/>
      </div>

      <Common :text="$t('home.slide05.block3.description')"/>

    </div>

  </div>

</div>

</template>

<script>
import Subtitle from '../general/texts/Subtitle.vue'
import Common from '../general/texts/Common.vue'
import Number from '../general/texts/Number.vue'

export default {
  name: 'Slide05',
  components: {
    Subtitle,
    Common,
    Number
  }
}
</script>

<style lang="scss" scoped>
.number {
  margin: 50px 0;
}

@media (max-width: 750px), (max-device-width: 750px) {
  .number {
    margin: 60px 0 30px 0;
  }
}
</style>
